import React from "react";
import PropTypes from "prop-types";
import SvgActionSuccessSelected from "@/assets/icons/action/success/selected.svg";

export default function ActionSuccessSelected(props) {
  const { style } = props;
  return (
    <SvgActionSuccessSelected
      viewBox="0 0 29 29"
      {...props}
      style={{ ...style, position: "relative", left: "1%", top: "5%" }}
    />
  );
}

ActionSuccessSelected.propTypes = {
  style: PropTypes.objectOf(PropTypes.any),
};

ActionSuccessSelected.defaultProps = {
  style: undefined,
};
